module.exports = __webpack_public_path__ + "static/media/mile8.425d47f5.jpg";